// Lightweight form validation utilities for React Hook Form
// No external validation library needed for our simple forms

// Validation patterns
const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Phone number formatter
export const formatPhoneNumber = (value) => {
  if (!value) return value;
  
  // Remove all non-numeric characters
  const phoneNumber = value.replace(/\D/g, '');
  
  // Limit to 10 digits
  const limitedPhoneNumber = phoneNumber.substring(0, 10);
  
  // Format as (XXX) XXX-XXXX
  if (limitedPhoneNumber.length >= 7) {
    return `(${limitedPhoneNumber.substring(0, 3)}) ${limitedPhoneNumber.substring(3, 6)}-${limitedPhoneNumber.substring(6)}`;
  } else if (limitedPhoneNumber.length >= 4) {
    return `(${limitedPhoneNumber.substring(0, 3)}) ${limitedPhoneNumber.substring(3)}`;
  } else if (limitedPhoneNumber.length >= 1) {
    return `(${limitedPhoneNumber}`;
  }
  
  return '';
};

// Email formatter (remove whitespace)
export const formatEmail = (value) => {
  if (!value) return value;
  return value.replace(/\s/g, '');
};

// React Hook Form validation rules
export const validationRules = {
  firstName: {
    required: 'First name is required',
    minLength: {
      value: 2,
      message: 'First name must be at least 2 characters'
    },
    maxLength: {
      value: 50,
      message: 'First name must be less than 50 characters'
    }
  },
  
  lastName: {
    required: 'Last name is required',
    minLength: {
      value: 2,
      message: 'Last name must be at least 2 characters'
    },
    maxLength: {
      value: 50,
      message: 'Last name must be less than 50 characters'
    }
  },

  fullName: {
    required: 'Full name is required',
    minLength: {
      value: 3,
      message: 'Full name must be at least 3 characters'
    },
    maxLength: {
      value: 100,
      message: 'Full name must be less than 100 characters'
    }
  },
  
  email: {
    required: 'Email is required',
    pattern: {
      value: emailRegex,
      message: 'Please enter a valid email address'
    }
  },
  
  phone: {
    required: 'Phone number is required',
    validate: (value) => {
      if (!phoneRegex.test(value)) {
        return 'Please enter a valid phone number: (XXX) XXX-XXXX';
      }
      return true;
    }
  },
  
  message: {
    required: 'Message is required',
    minLength: {
      value: 10,
      message: 'Message must be at least 10 characters'
    },
    maxLength: {
      value: 1000,
      message: 'Message must be less than 1000 characters'
    }
  },

  messageOptional: {
    maxLength: {
      value: 1000,
      message: 'Message must be less than 1000 characters'
    }
  },
  
  agreeToTextMessages: {
    required: 'You must agree to receive text messages'
  },

  companyName: {
    required: 'Company name is required',
    minLength: {
      value: 2,
      message: 'Company name must be at least 2 characters'
    },
    maxLength: {
      value: 100,
      message: 'Company name must be less than 100 characters'
    }
  },

  personalName: {
    required: 'Your name is required',
    minLength: {
      value: 2,
      message: 'Your name must be at least 2 characters'
    },
    maxLength: {
      value: 100,
      message: 'Your name must be less than 100 characters'
    }
  }
};